import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { DateValue, FlexBox } from '@dfl/mui-react-common';
import { IShipping } from 'modules/sales/common/interfaces/IOrder';
import { Typography } from '@mui/material';

type Props = {
  value: IShipping;
};

const OnDemandDateCell = ({ value: data }: Props) => {
  const { t } = useTranslation('homeDelivery');

  return (
    <FlexBox alignItems={'center'} gap={0.5} flexWrap={'wrap'}>
      <DateValue value={data?.onDemandDate} format='dd/MM/yyyy' />
      {data?.onDemandHours?.from && data?.onDemandHours?.to && (
        <Typography>
          | {data?.onDemandHours?.from}:00 - {data?.onDemandHours?.to}:00 {t('common:hours')}
        </Typography>
      )}
    </FlexBox>
  );
};

export default memo(OnDemandDateCell);
